// TopViewControl.js
//import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle } from '../value/AppConst';

export const TopControllerContainer = styled(Box)({
    display: 'flex', alignItems: 'center', justifyContent:'center', height: '100%',
});
export const TopControllerSideBox = styled(Box)({width:'5%', maxWidth:180, minWidth:30, height: '100%',});
export const TopControllerCenterBox = styled(Box)({
    flexGrow:1, height: '100%',maxWidth:AppStyle.MaxDataBodyWidth, minWidth:300, // marginLeft: 10, marginRight: 10,
});

// Inside TopControllerCenterBox
export const ContentConainer = styled(Box)({
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    height: '100%', width: '100%', boxSizing: 'border-box',
    padding: '0px 10px 0px 10px',
});
export const HoriContentContainer = styled(Box)({
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    height: '100%', width: '100%', boxSizing: 'border-box',
    padding: '0px 10px 0px 10px', // backgroundColor: 'yellow'
});
// BigContentColumn inside HoriContentContainer
export const BigContentColumn = styled(Box)({
    display: 'flex', flexDirection: 'column', height: '100%', margin: 5,
});
export const ContentTabs = styled(Box)({
    display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%',
});
export const ContentHeader = styled(Box)({
    padding: '8px 5px 5px 5px', width: '100%', boxSizing: 'border-box',
    display: 'flex', alignItems: 'center', 
});
export const ContentBody = styled(Box)({
    flexGrow: 1, padding: '0px 5px 0px 5px', width: '100%', boxSizing: 'border-box',
});

export const ControlBox = styled(Box)({flexGrow:1, display:'flex', alignItems:'center'});

export const ToolBox = styled(Box)({
    display:'flex', alignItems:'center', justifyContent:'flex-end',
    padding:'1px 8px 1px 5px', border: AppStyle.BorderCCC, borderRadius:5,
    fontSize:'0.85rem', color: '#333333',
});

export const WaitingFullsize = styled(Box)({
    position: 'fixed', top:0, left:0, width:'100vw', height:'100vh',
    backgroundColor: 'white', opacity: 0.5,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 99999,
    fontSize: '1.5rem', fontWeight: 'bold',
    color: AppStyle.PrimaryRGB,
});

export const FullsizeWaiting = ({message}) => {
    return(
        <WaitingFullsize>
            <span>{message || '잠시만 기다려주세요...'}</span>
        </WaitingFullsize>
    );
};

export const CountLabel = ({count, countLabel}) => {
    return(
        <span style={{padding:5, fontSize:'0.85rem', color: AppStyle.PrimaryRGB}}>
            {count} {countLabel || '건'}
        </span>
    );
};

export default function TopViewControl({children, parentMenu}) {
    return(
        <TopControllerContainer>
            <TopControllerCenterBox>{children}</TopControllerCenterBox>
        </TopControllerContainer>
    );
};

